import React from 'react';
import { Pane } from '@leverege/ui-elements';
import Detail from './Detail';
import S from './CardStyle.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CustomerInfoCard(props) {
  const {
    acct
  } = props;
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dashboardCard",
    className: S.container,
    children: /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      variant: "dataCard",
      children: [/*#__PURE__*/_jsx(Detail, {
        label: "Name",
        value: acct?.name,
        type: "column"
      }), /*#__PURE__*/_jsx(Detail, {
        label: "Account Email",
        value: acct?.username,
        type: "column"
      }), /*#__PURE__*/_jsx(Detail, {
        label: "Phone Number",
        value: acct?.phone,
        type: "column"
      }), /*#__PURE__*/_jsx(Detail, {
        label: "Address",
        value: acct?.address?.location,
        type: "column"
      })]
    })
  });
}